import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeriodicPopupComponent } from './periodic-popup.component';
import { CustomDropdownModule } from "../../../shared/components/custom-dropdown/custom-dropdown.module";
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomInputModule } from "../../../shared/components/custom-input/custom-input.module";
import { MultiSelectDropdownModule } from "../../../shared/components/multi-select-dropdown/multi-select-dropdown.module";



@NgModule({
  declarations: [
    PeriodicPopupComponent
  ],
  imports: [
    CommonModule,
    CustomDropdownModule,
    MaterialModule,
    FormsModule,
    CustomInputModule,
    ReactiveFormsModule,
    MultiSelectDropdownModule
],
  exports:[
    PeriodicPopupComponent
  ]
})
export class PeriodicPopupModule { }
